/* eslint-disable */

import React from "react";
import ModelComponent from "../model-component/model-component.tsx";
import RaindropInput from "../raindrop-input/raindrop-input.tsx";

const ModelComponentNote = ({ id, text, createdAt, createdBy }) => {
  return (
    <ModelComponent
      modelId={id}
      colorBorderAccent="dark:border-color-dark-model-note border-color-model-note"
    >
      <RaindropInput
        label={"Note"}
        value={text}
        icon=""
        isEditing={false}
        isShowLabel={true}
      />

      <RaindropInput
        label={"Created At"}
        value={createdAt}
        icon=""
        isEditing={false}
        isShowLabel={true}
      />

      <RaindropInput
        label={"Created By"}
        value={createdBy}
        icon=""
        isEditing={false}
        isShowLabel={true}
      />
    </ModelComponent>
  );
};

export default ModelComponentNote;
